import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import visaMstrcard from "../../assets/visa-mstrcard.svg";
import knet from "../../assets/knet.svg";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import UserAddressService from "../../services/UserAddressService";
import { useNavigate } from "react-router-dom";
import { Accordion, Badge, Button, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import CartService from "../../services/CartService";
import OrderService from "../../services/OrderService";
import { setCart, setPromoCode } from "../../store/actions/AuthActions";
import { AvField, AvForm } from "availity-reactstrap-validation";
import CountryService from "../../services/CountryService";
import AddAddress from "./Address";
import OrderGuestService from "../../services/OrderGuestService";
import ServiceFeeService from "../../services/ServiceFeeService";
import logoImg from "../../assets/logo.svg";
import "./style.css";

const Checkout = () => {
	const [formData, setFormData] = useState({
		addressName: "",
		block: "",
		street: "",
		area_id: 0,
		governorate_id: 0,
		type: "",
		avenue: "",
		buildingNumber: "",
		floorNumber: "",
		officeNumber: "",
		houseNumber: "",
		aptNumber: "",
		otherInstructions: "",
		longitude: 0,
		latitude: 0,
		guest_name: "",
		guest_email: "",
		guest_phone: "",
	});
	const { t } = useTranslation();
	const [governorateOptions, setGovernorateOptions] = useState([]);
	const [areaOptions, setAreaOptions] = useState([]);
	const typesOptions = [
		{ label: t("House"), value: "house" },
		{ label: t("Building Number"), value: "building" },
		{ label: t("Office"), value: "office" },
	];
	const [isLogin, setIsLogin] = useState(null);
	const [address, setAddress] = useState([]);
	const [paymentMethod, setPaymentMethod] = useState("knet");
	const [deliveryPossibility, setDeliveryPossibility] = useState({});
	const [addNewAddress, setAddNewAddress] = useState(false);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const lang = useSelector((state) => state?.lang?.lang);
	const [totalPrice, setTotalPrice] = useState(0);
	const [totalPriceAfterDis, setTotalPriceAfterDis] = useState(0);
	const [deliveryChargess, setDeliveryChargess] = useState(0);
	const [discountAmount, setDiscountAmount] = useState(0);
	const [cashInDelivery, setCashInDelivery] = useState(0);
	const [coupon, setCoupon] = useState("");
	const [paymentType, setPaymentType] = useState("knet");
	const [couponDetails, setCouponDetails] = useState("");
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [shouldUpdateSummary, setShouldUpdateSummary] = useState(false);
	const [shouldUpdateAddress, setShouldUpdateAddress] = useState(false);
	const [loadin, setLoading] = useState(false);
	const [cartId, setCartId] = useState("");
	const [cartProducts, setCartProducts] = useState([]);
	const user = useSelector((state) => state?.user?.user);
	const userAddressService = new UserAddressService();
	const cartService = new CartService();
	const orderService = new OrderService();
	const orderGuestService = new OrderGuestService();
	const serviceFeeService = new ServiceFeeService();
	const cart = useSelector((state) => state?.user?.cart);

	// Address
	useEffect(() => {
		if (!!user) {
			setIsLogin(1);
			userAddressService
				.getList()
				.then((res) => {
					if (res?.status) {
						let response = res?.data?.data;
						setAddress(response);
					}
				})
				.catch(() => {});
		} else {
			setIsLogin(0);
		}
	}, [user, shouldUpdateAddress]);

	// Country
	useEffect(() => {
		new CountryService()?.getList().then((res) => {
			if (res?.status === 200) {
				let data = res?.data?.data?.map((country) => {
					return {
						...country,
						label: lang === "en" ? country?.name_en : country?.name_ar,
						value: country?.id,
					};
				});
				setGovernorateOptions(data);
			}
		});
	}, [lang]);

	useEffect(() => {
		if (!user && !!formData?.governorate_id?.id) {
			serviceFeeService?.getList().then((res) => {
				if (res?.status) {
					if (res?.data?.data?.delivery_possibility) {
						setDeliveryPossibility(res?.data?.data);
					}
				}
			});
		}
	}, [formData?.governorate_id]);

	// Areas
	useEffect(() => {
		if (!!formData?.governorate_id?.id) {
			new CountryService()
				?.getArea(formData?.governorate_id?.id)
				.then((res) => {
					if (res?.status === 200) {
						let data = res?.data?.data?.map((area) => {
							return {
								...area,
								label: lang === "en" ? area?.name_en : area?.name_ar,
								value: area?.id,
							};
						});
						setAreaOptions(data);
					}
				});
		}
	}, [lang, formData?.governorate_id]);

	// Cart
	useEffect(() => {
		if (!!user) {
			cartService
				.getList()
				.then((res) => {
					if (res?.status === 200) {
						let data = res?.data.data;
						setCartId(data?.id);
						setCartProducts(data?.sub_carts);
						setTotalPrice(data?.sub_total);
						setTotalPriceAfterDis(data?.total);
						setDiscountAmount(data?.discount_amount);
						if (!!data?.coupon_name) {
							setCoupon(data?.coupon_name);
							setCouponDetails({
								coupon: data?.coupon_name,
								coupon_type: data?.coupon_type,
								coupon_value: data?.coupon_value,
							});
							dispatch(
								setPromoCode({
									coupon: data?.coupon_name,
									coupon_type: data?.coupon_type,
									coupon_value: data?.coupon_value,
								})
							);
						}
					}
					setLoading(false);
				})
				.catch((e) => {
					if (e.response.data?.message === "cart_not_Exist") {
						navigate("/");
					}
					setLoading(false);
				});
		} else {
			let data = cart?.map((item) => {
				return {
					amount: item?.amount,
					product: item,
				};
			});
			setLoading(false);
			let totalP = data
				?.map((res) => {
					let tot =
						res?.product?.amount *
						(res?.product?.offer
							? res?.product?.offerPrice
							: res?.product?.price);
					return tot;
				})
				.reduce((accumulator, currentValue) => {
					return accumulator + currentValue;
				}, 0);

			setTotalPrice(totalP);
			setCartProducts(data);

			let dis;
			if (couponDetails?.coupon_type === "percentage") {
				dis =
					Number(totalP) -
					Number(totalP) * (Number(couponDetails?.coupon_value) / 100);
			} else if (couponDetails?.coupon_type === "fixed") {
				dis = Number(totalP) - Number(couponDetails?.coupon_value);
			} else {
				dis = Number(totalP);
			}
			setTotalPriceAfterDis(dis);
		}
	}, [user, cart, shouldUpdate]);

	useEffect(() => {
		if (!!address?.length && !!cartId) {
			let data = {
				cart_id: cartId,
				user_address_id: address.find((res) => res.is_default)?.id,
				payment_method: paymentMethod === "cash" ? "cash" : "visa",
			};
			cartService.summary(data).then((res) => {
				if (res?.status) {
					let data = res?.data?.data;
					setDeliveryChargess(data?.shipping_fee);
					setCashInDelivery(data?.cash_in_delivery || 0);
					setTotalPrice(data?.sub_total);
					setTotalPriceAfterDis(data?.total);
					setDiscountAmount(data?.discount_amount);
				}
			});
		}
	}, [cartId, address, paymentMethod, shouldUpdateSummary]);

	const setDefault = (id) => {
		userAddressService.updateDefaultAddress(id).then((res) => {
			if (res?.status === 200) {
				toast.success(t("Address Updated Successfully."));
				setShouldUpdateAddress((prev) => !prev);
			}
		});
	};

	const submitOrder = () => {
		if (isLogin === 1) {
			if (address?.length === 0) {
				toast.error(t("Add Address First"));
				return;
			}
			let data = {
				payment_method: paymentMethod === "cash" ? "cash" : "visa",
				user_address_id: address.find((res) => res.is_default)?.id,
				cart_id: cartId,
			};
			if (paymentMethod !== "cash") data["paymentType"] = paymentType;
			orderService
				.create(data)
				.then((res) => {
					if (res?.status) {
						if (paymentMethod !== "cash") {
							// localStorage.removeItem('CornyStoreCart')
							// localStorage.removeItem('PromoCodeCornyStore')
							// dispatch(setCart([]))
							window.location.href = res.data?.data;
							return;
						}
						navigate("/order-successful");
					}
				})
				.catch((e) => {
					toast.error(e?.response?.data?.message.replaceAll("_", " "));
				});
		} else {
			if (
				!formData?.area_id?.id ||
				!formData?.governorate_id?.id ||
				!formData?.type?.value
			) {
				return;
			}

			let total = totalPriceAfterDis;
			if (deliveryPossibility?.delivery_possibility) {
				if (paymentMethod === "cash")
					total += deliveryPossibility?.cash_in_delivery;

				if (deliveryPossibility?.delivery_all_area) {
					total += deliveryPossibility?.delivery_fee;
				} else {
					total += formData?.area_id?.delivery_fee || 0;
				}
			}

			let data = {
				products: cartProducts?.map((res) => {
					return {
						amount: res?.amount,
						product_id: res?.product?.id,
						dynamic_variant: res?.dynamicVariants?.map((variant) => {
							let response = {
								dynamic_variant_id: variant?.id,
							};
							if (!!variant?.amount) response["amount"] = variant?.amount;
							return response;
						}),
					};
				}),
				guest_name: formData?.guest_name,
				guest_email: formData?.guest_email,
				guest_phone: formData?.guest_phone,
				// total: total,
				payment_method: paymentMethod === "cash" ? "cash" : "visa",
				addressName: formData?.addressName,
				block: formData?.block,
				street: formData?.street,
				area_id: formData?.area_id?.id,
				governorate_id: formData?.governorate_id?.id,
				type: formData?.type?.value,
			};
			if (paymentMethod !== "cash") data["paymentType"] = paymentType;
			if (!!formData?.avenue) data["avenue"] = formData?.avenue;
			if (!!formData?.buildingNumber)
				data["buildingNumber"] = formData?.buildingNumber;
			if (!!formData?.floorNumber) data["floorNumber"] = formData?.floorNumber;
			if (!!formData?.officeNumber)
				data["officeNumber"] = formData?.officeNumber;
			if (!!formData?.houseNumber) data["houseNumber"] = formData?.houseNumber;
			if (!!formData?.aptNumber) data["aptNumber"] = formData?.aptNumber;
			if (!!formData?.otherInstructions)
				data["otherInstructions"] = formData?.otherInstructions;

			orderGuestService
				.create(data)
				.then((res) => {
					if (res?.status) {
						if (paymentMethod !== "cash") {
							window.location.href = res.data?.data;
							return;
						}
						navigate("/order-successful");
					}
				})
				.catch((e) => {
					toast.error(e?.response?.data?.message.replaceAll("_", " "));
				});
		}
	};

	const commonLines = () => {
		toast.success(t("Remove"));
		// dispatch(setPromoCode(""));
		localStorage.removeItem("PromoCodeCornyStore");
		setCoupon("");
		setCouponDetails("");
		setShouldUpdate((prev) => !prev);
		setShouldUpdateSummary((prev) => !prev);
	};

	const promoCodeFun = () => {
		let data = {
			promoCode: coupon,
		};
		if (!!cartId) data["cart_id"] = cartId;
		cartService
			.createPromoCode(data)
			.then((res) => {
				if (res?.status === 200) {
					toast.success(t("Successfully Applied"));
					setCouponDetails({ coupon, ...res?.data?.data });
					localStorage.setItem(
						"PromoCodeCornyStore",
						JSON.stringify({ coupon: coupon, ...res?.data?.data })
					);
					// dispatch(setPromoCode({ coupon: coupon, ...res?.data?.data }));
					if (!!address?.length && !!cartId) {
						setShouldUpdateSummary((prev) => !prev);
					} else {
						setShouldUpdate((prev) => !prev);
					}
				}
			})
			.catch((e) => {
				if (e?.response.data?.message === "promo_code_not_Exist") {
					toast.error(t("promo code is invalid!"));
				}
			});
	};

	const removePromoCode = () => {
		let data = {
			cart_id: cartId,
		};
		if (!!user) {
			cartService.deletePromoCode(data).then((res) => {
				if (res?.status === 200) commonLines();
			});
		} else {
			commonLines();
		}
	};

	return (
		<section className="checkout_page stage_padding">
			<div className="container">
				<div className="row">
					<div className="col-lg-8 mb-3">
						<div className="checkout-card">
							<div className="sec_head">
								<h4 className="m-0">{t("Checkout")}</h4>
							</div>
							{cartProducts?.map((product) => {
								return (
									<div key={product?.product?.id} className="product-cart">
										<div className="row px-2">
											<div
												className="col-md-9 col-12 d-flex"
												style={{ gap: "16px" }}>
												<img
													src={
														product?.product?.product_images[0]?.url || logoImg
													}
													alt="img"
													width={90}
													height={90}
												/>
												<div>
													<h5 className="product-name mb-1">
														{lang === "en"
															? product?.product?.name_en
															: product?.product?.name_ar}
													</h5>
													<h5 className="product-amount mb-2">
														{product?.amount} *{" "}
														{(product?.product?.offer
															? product?.product?.offerPrice
															: product?.product?.price
														).toFixed(3)}
													</h5>
													{isLogin === 1
														? product?.dynamic_variant_carts?.map((dy, ind) => {
																return (
																	<h6 key={ind}>
																		{lang === "en"
																			? dy?.dynamic_variant?.name_en
																			: dy?.dynamic_variant?.name_ar}{" "}
																		({dy?.amount} *{" "}
																		{dy?.dynamic_variant?.price?.toFixed(3)})
																	</h6>
																);
														  })
														: product?.dynamicVariants?.map((dy, ind) => {
																return (
																	<h6 key={ind}>
																		{lang === "en" ? dy?.name_en : dy?.name_ar}{" "}
																		({dy?.amount} * {dy?.price?.toFixed(3)})
																	</h6>
																);
														  })}
												</div>
											</div>
											<div className="col-md-3 col-12">
												<div className="text-center">
													{isLogin === 0 &&
														(product?.dynamicVariants?.length ? (
															<h4
																style={{ dontSize: "18px" }}
																className="mb-3 text-primary">
																{(
																	product?.amount *
																		(product?.product?.offer
																			? product?.product?.offerPrice
																			: product?.product?.price) +
																	product?.dynamicVariants
																		?.map((res) => res?.amount * res?.price)
																		.reduce((accumulator, currentValue) => {
																			return accumulator + currentValue;
																		}, 0)
																).toFixed(3)}{" "}
																{t("KWD")}
															</h4>
														) : (
															<h4
																style={{ dontSize: "18px" }}
																className="mb-3 text-primary">
																{(
																	product?.amount *
																	(product?.product?.offer
																		? product?.product?.offerPrice
																		: product?.product?.price)
																).toFixed(3)}{" "}
																{t("KWD")}
															</h4>
														))}

													{isLogin === 1 &&
														(product?.dynamic_variant_carts?.length ? (
															<h4 className="mb-3 text-primary">
																{(
																	product?.amount *
																		(product?.product?.offer
																			? product?.product?.offerPrice
																			: product?.product?.price) +
																	product?.dynamic_variant_carts
																		?.map(
																			(res) =>
																				res?.amount *
																				res?.dynamic_variant?.price
																		)
																		.reduce((accumulator, currentValue) => {
																			return accumulator + currentValue;
																		}, 0)
																).toFixed(3)}{" "}
																{t("KWD")}
															</h4>
														) : (
															<h4
																style={{ dontSize: "18px" }}
																className="mb-3 text-primary">
																{(
																	product?.amount *
																	(product?.product?.offer
																		? product?.product?.offerPrice
																		: product?.product?.price)
																).toFixed(3)}{" "}
																{t("KWD")}
															</h4>
														))}
												</div>
											</div>
										</div>
									</div>
								);
							})}

							{isLogin === 1 && (
								<div className="p-3 address">
									<h5 className="fw-bold mb-3">{t("address")}</h5>
									<Button
										variant="primary"
										onClick={() => setAddNewAddress(true)}
										className="fw-bold px-5">
										{t("Add New Address")}
									</Button>
									{!!address?.length && (
										<Accordion className="mt-4" defaultActiveKey="0">
											{address?.map((addressData, index) => {
												return (
													<Accordion.Item eventKey={index}>
														<Accordion.Header>
															{addressData?.addressName}
															{addressData?.is_default && (
																<span
																	style={{
																		fontSize: "14px",
																		borderRadius: "6px",
																		color: "#000",
																		background: "var(--bg-primary-color)",
																	}}
																	className="mx-4 p-2 fw-bold">
																	{t("Default")}
																</span>
															)}
														</Accordion.Header>
														<Accordion.Body>
															<Row>
																<Col md={6}>
																	<label>{t("Address Name")}</label>
																	<p>{addressData.addressName}</p>
																</Col>
																<Col md={6}>
																	<label>{t("Block")}</label>
																	<p>{addressData.block}</p>
																</Col>
																<Col md={6}>
																	<label>{t("Street")}</label>
																	<p>{addressData.street}</p>
																</Col>
																<Col md={6}>
																	<label>{t("Governorate")}</label>
																	<p>
																		{lang === "en"
																			? addressData?.governorate?.name_en
																			: addressData?.governorate?.name_ar}
																	</p>
																</Col>
																<Col md={6} className="mb-3">
																	<label>{t("Area")}</label>
																	<p>
																		{lang === "en"
																			? addressData?.area?.name_en
																			: addressData?.area?.name_ar}
																	</p>
																</Col>
																<Col md={6} className="mb-3">
																	<label>{t("Address Type")}</label>
																	<p>{t(addressData.type)}</p>
																</Col>
																<Col md={6}>
																	<label>{t("Avenue")}</label>
																	<p>{addressData.avenue}</p>
																</Col>
																<Col md={6}>
																	<label>{t("Building Number")}</label>
																	<p>{addressData.buildingNumber}</p>
																</Col>
																<Col md={6}>
																	<label>{t("Floor Number")}</label>
																	<p>{addressData.floorNumber}</p>
																</Col>
																<Col md={6}>
																	<label>{t("Office Number")}</label>
																	<p>{addressData.officeNumber}</p>
																</Col>
																<Col md={6}>
																	<label>{t("House Number")}</label>
																	<p>{addressData.houseNumber}</p>
																</Col>
																<Col md={6}>
																	<label>{t("Apartment Number")}</label>
																	<p>{addressData.aptNumber}</p>
																</Col>
																{!!addressData.otherInstructions && (
																	<Col md={12}>
																		<label>{t("Other Instructions")}</label>
																		<p>{addressData.otherInstructions}</p>
																	</Col>
																)}
															</Row>
															<div className="mt-3 d-flex justify-content-between">
																{!addressData?.is_default && (
																	<Button
																		variant="warning"
																		onClick={() => setDefault(addressData?.id)}
																		type="button">
																		{t("Set Default")}
																	</Button>
																)}
															</div>
														</Accordion.Body>
													</Accordion.Item>
												);
											})}
										</Accordion>
									)}
								</div>
							)}

							{isLogin === 0 && (
								<div className="cont-checkout px-3 pb-2 wow fadeInUp">
									<AvForm
										className="form-checkout mt-4 form-st guestForm form-horizontal"
										onValidSubmit={() => {}}>
										<Row>
											<Col md={6}>
												<AvField
													label={t("Name")}
													type="text"
													placeholder={t("Name")}
													bsSize="lg"
													name="name"
													validate={{
														required: {
															value: true,
															errorMessage: t("This Field is required"),
														},
													}}
													value={formData.guest_name}
													onChange={(e) =>
														setFormData({
															...formData,
															guest_name: e.target.value,
														})
													}
												/>
											</Col>
											<Col md={6}>
												<AvField
													label={t("Email")}
													type="email"
													placeholder={t("Email")}
													bsSize="lg"
													name="email"
													validate={{
														required: {
															value: true,
															errorMessage: t("This Field is required"),
														},
													}}
													value={formData.guest_email}
													onChange={(e) =>
														setFormData({
															...formData,
															guest_email: e.target.value,
														})
													}
												/>
											</Col>
											<Col md={6}>
												<AvField
													label={t("Phone")}
													type="number"
													placeholder={t("Phone")}
													bsSize="lg"
													name="phone"
													validate={{
														required: {
															value: true,
															errorMessage: t("This Field is required"),
														},
													}}
													value={formData.guest_phone}
													onChange={(e) =>
														setFormData({
															...formData,
															guest_phone: e.target.value,
														})
													}
												/>
											</Col>
											<Col md={6}>
												<AvField
													label={t("Address Name")}
													type="text"
													placeholder={t("Address Name")}
													bsSize="lg"
													name="addressName"
													validate={{
														required: {
															value: true,
															errorMessage: t("This Field is required"),
														},
													}}
													value={formData.addressName}
													onChange={(e) =>
														setFormData({
															...formData,
															addressName: e.target.value,
														})
													}
												/>
											</Col>
											<Col md={6}>
												<AvField
													label={t("Block")}
													type="text"
													placeholder={t("Block")}
													bsSize="lg"
													name="block"
													validate={{
														required: {
															value: true,
															errorMessage: t("This Field is required"),
														},
													}}
													value={formData.block}
													onChange={(e) =>
														setFormData({
															...formData,
															block: e.target.value,
														})
													}
												/>
											</Col>
											<Col md={6}>
												<AvField
													label={t("Street")}
													type="text"
													placeholder={t("Street")}
													bsSize="lg"
													name="street"
													validate={{
														required: {
															value: true,
															errorMessage: t("This Field is required"),
														},
													}}
													value={formData.street}
													onChange={(e) =>
														setFormData({
															...formData,
															street: e.target.value,
														})
													}
												/>
											</Col>
											<Col className="col-6 mb-3">
												<label className="mb-2">{t("Governorate")}</label>
												<Select
													options={governorateOptions}
													name="governorate"
													placeholder={t("Please Select")}
													value={formData?.governorate_id}
													styles={{
														height: "48px",
													}}
													onChange={(e) =>
														setFormData({ ...formData, governorate_id: e })
													}
												/>
											</Col>
											<Col className="col-6 mb-3">
												<label className="mb-2">{t("Area")}</label>
												<Select
													options={areaOptions}
													name="area_id"
													placeholder={t("Please Select")}
													value={formData?.area_id}
													styles={{
														height: "48px",
													}}
													onChange={(e) =>
														setFormData({ ...formData, area_id: e })
													}
												/>
											</Col>
											<Col className="col-6 mb-3">
												<label className="mb-2">{t("Address Type")}</label>
												<Select
													options={typesOptions}
													name="type"
													placeholder={t("Please Select")}
													styles={{
														height: "48px",
													}}
													value={formData?.type}
													onChange={(e) =>
														setFormData({ ...formData, type: e })
													}
												/>
											</Col>
											<Col className="col-6">
												<label className="mb-2">{t("Apartment Number")}</label>
												<AvField
													type="text"
													placeholder={t("Apartment Number")}
													bsSize="lg"
													className="m-0"
													validate={{
														required: {
															value: true,
															errorMessage: t("This Field is required"),
														},
													}}
													name="aptNumber"
													value={formData.aptNumber}
													onChange={(e) =>
														setFormData({
															...formData,
															aptNumber: e.target.value,
														})
													}
												/>
											</Col>
											<Col md={6}>
												<AvField
													label={t("Avenue")}
													type="text"
													placeholder={t("Avenue")}
													bsSize="lg"
													name="avenue"
													value={formData.avenue}
													onChange={(e) =>
														setFormData({
															...formData,
															avenue: e.target.value,
														})
													}
												/>
											</Col>
											{formData?.type?.value === "building" && (
												<Col md={6}>
													<AvField
														label={t("Building Number")}
														type="text"
														placeholder={t("Building Number")}
														bsSize="lg"
														name="buildingNumber"
														value={formData.buildingNumber}
														onChange={(e) =>
															setFormData({
																...formData,
																buildingNumber: e.target.value,
															})
														}
													/>
												</Col>
											)}
											{formData?.type?.value === "building" && (
												<Col md={6}>
													<AvField
														label={t("Floor Number")}
														type="text"
														placeholder={t("Floor Number")}
														bsSize="lg"
														validate={{
															required: {
																value: true,
																errorMessage: t("This Field is required"),
															},
														}}
														name="floorNumber"
														value={formData.floorNumber}
														onChange={(e) =>
															setFormData({
																...formData,
																floorNumber: e.target.value,
															})
														}
													/>
												</Col>
											)}
											{formData?.type?.value === "office" && (
												<Col md={6}>
													<AvField
														label={t("Office Number")}
														type="text"
														placeholder={t("Office Number")}
														bsSize="lg"
														validate={{
															required: {
																value: true,
																errorMessage: t("This Field is required"),
															},
														}}
														name="officeNumber"
														value={formData.officeNumber}
														onChange={(e) =>
															setFormData({
																...formData,
																officeNumber: e.target.value,
															})
														}
													/>
												</Col>
											)}
											{formData?.type?.value === "house" && (
												<Col md={6}>
													<AvField
														label={t("House Number")}
														type="text"
														placeholder={t("House Number")}
														bsSize="lg"
														validate={{
															required: {
																value: true,
																errorMessage: t("This Field is required"),
															},
														}}
														name="houseNumber"
														value={formData.houseNumber}
														onChange={(e) =>
															setFormData({
																...formData,
																houseNumber: e.target.value,
															})
														}
													/>
												</Col>
											)}

											<Col md={12}>
												<AvField
													label={t("Other Instructions")}
													type="text"
													placeholder={t("Other Instructions")}
													bsSize="lg"
													name="otherInstructions"
													value={formData.otherInstructions}
													onChange={(e) =>
														setFormData({
															...formData,
															otherInstructions: e.target.value,
														})
													}
												/>
											</Col>
										</Row>
									</AvForm>
								</div>
							)}
							{addNewAddress && isLogin === 1 && (
								<AddAddress
									modal={addNewAddress}
									setModal={setAddNewAddress}
									setShouldUpdateAddress={setShouldUpdateAddress}
								/>
							)}
						</div>
					</div>

					<div className="col-lg-4">
						{isLogin === 1 && (
							<div className="checkout-card coupon-code mb-4 wow fadeInUp">
								<div className="sec_head">
									<h4 className="m-0">{t("Coupon Code")}</h4>
								</div>
								<div className="form-coupon p-3">
									<div className="form-group">
										<input
											type="text"
											required
											value={coupon}
											onChange={(e) => setCoupon(e.target.value)}
											disabled={!!couponDetails?.coupon}
											className="form-control"
											name="code_name"
											id="code_name"
											placeholder={t("Please Enter")}
										/>
										{!couponDetails?.coupon && (
											<button
												className="btn-site"
												onClick={() => promoCodeFun()}>
												<span className="fw-bold">{t("Apply")}</span>
											</button>
										)}
										{!!couponDetails?.coupon && (
											<button
												className="btn-danger py-1"
												onClick={removePromoCode}>
												<span className="fw-bold">{t("Remove")}</span>
											</button>
										)}
									</div>
								</div>
							</div>
						)}
						<div className="checkout-card payment-method wow fadeInUp">
							<div className="sec_head">
								<h4 className="m-0">{t("Payment Method")}</h4>
							</div>
							<div className="list-pay p-3">
								<div>
									<input
										className="form-check-input"
										onClick={() => setPaymentMethod("knet")}
										type="radio"
										name="payment_type"
										id="knet"
										value="knet"
										checked={paymentMethod === "knet"}
									/>
									<label className="form-check-label fw-bold" for="knet">
										<img src={knet} alt="knet" width={16} height={16} />
										{t("Knet")}
									</label>
								</div>
								{/* <div>
									<input
										className="form-check-input"
										onClick={() => setPaymentMethod("visa")}
										type="radio"
										name="payment_type"
										id="ch-visa"
										value="visa"
										checked={paymentMethod === "visa"}
									/>
									<label className="form-check-label fw-bold" for="ch-visa">
										<img src={visaMstrcard} alt="visa" width={16} height={16} />
										{t("Visa/MasterCard")}
									</label>
								</div> */}
								{/* <div>
									<input
										className="form-check-input"
										type="radio"
										name="payment_type"
										id="ch-cash"
										value="cash"
										onClick={() => setPaymentMethod("cash")}
										checked={paymentMethod === "cash"}
									/>
									<label className="form-check-label fw-bold" for="ch-cash">
										<svg
											width="20"
											height="23"
											viewBox="0 0 20 23"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M10.1655 0.467163C8.97357 0.467104 7.80837 0.820504 6.81727 1.48267C5.82617 2.14484 5.05369 3.08604 4.5975 4.18724C4.14132 5.28845 4.02193 6.50019 4.25444 7.66925C4.48694 8.83831 5.06089 9.91216 5.9037 10.755C6.74652 11.5979 7.82035 12.1719 8.98939 12.4044C10.1584 12.637 11.3702 12.5177 12.4714 12.0615C13.5726 11.6054 14.5139 10.833 15.1761 9.84192C15.8383 8.85085 16.1918 7.68567 16.1918 6.49371C16.1918 4.89542 15.5569 3.36259 14.4267 2.2324C13.2966 1.10222 11.7638 0.467243 10.1655 0.467163ZM9.69366 6.067H10.6202C11.0354 6.06661 11.4338 6.23119 11.7277 6.52453C12.0216 6.81786 12.1869 7.21593 12.1873 7.63116C12.1876 8.04639 12.0231 8.44477 11.7297 8.73866C11.4364 9.03254 11.0383 9.19786 10.6231 9.19825V9.96959C10.6247 10.0371 10.6129 10.1042 10.5882 10.1671C10.5635 10.2299 10.5265 10.2872 10.4793 10.3355C10.4321 10.3838 10.3758 10.4222 10.3136 10.4484C10.2514 10.4747 10.1845 10.4882 10.117 10.4882C10.0495 10.4882 9.98264 10.4747 9.92042 10.4484C9.8582 10.4222 9.80185 10.3838 9.7547 10.3355C9.70754 10.2872 9.67052 10.2299 9.64583 10.1671C9.62113 10.1042 9.60926 10.0371 9.6109 9.96959V9.19844H8.55475C8.42048 9.19844 8.29172 9.1451 8.19678 9.05016C8.10184 8.95522 8.0485 8.82645 8.0485 8.69219C8.0485 8.55792 8.10184 8.42916 8.19678 8.33422C8.29172 8.23927 8.42048 8.18594 8.55475 8.18594H10.6202C10.6934 8.18679 10.766 8.17311 10.8338 8.1457C10.9017 8.11828 10.9634 8.07768 11.0155 8.02623C11.0675 7.97478 11.1088 7.91352 11.1371 7.84599C11.1653 7.77845 11.1798 7.706 11.1798 7.63281C11.1798 7.55963 11.1653 7.48717 11.1371 7.41964C11.1088 7.35211 11.0675 7.29084 11.0155 7.2394C10.9634 7.18795 10.9017 7.14734 10.8338 7.11993C10.766 7.09251 10.6934 7.07884 10.6202 7.07969H9.69366C9.26471 7.08063 8.85241 6.91368 8.54496 6.61455C8.23752 6.31542 8.05933 5.90785 8.04852 5.47903C8.0377 5.05021 8.19512 4.63419 8.4871 4.31994C8.77908 4.00569 9.18244 3.81818 9.6109 3.7975V3.01791C9.60926 2.95041 9.62113 2.88327 9.64583 2.82043C9.67052 2.75759 9.70754 2.70032 9.7547 2.652C9.80185 2.60368 9.8582 2.56528 9.92042 2.53906C9.98264 2.51285 10.0495 2.49934 10.117 2.49934C10.1845 2.49934 10.2514 2.51285 10.3136 2.53906C10.3758 2.56528 10.4321 2.60368 10.4793 2.652C10.5265 2.70032 10.5635 2.75759 10.5882 2.82043C10.6129 2.88327 10.6247 2.95041 10.6231 3.01791V3.78895H11.7763C11.9106 3.78895 12.0393 3.84229 12.1343 3.93723C12.2292 4.03217 12.2825 4.16093 12.2825 4.2952C12.2825 4.42947 12.2292 4.55823 12.1343 4.65317C12.0393 4.74811 11.9106 4.80145 11.7763 4.80145H9.69366C9.52585 4.80145 9.36491 4.86811 9.24625 4.98677C9.12759 5.10544 9.06092 5.26638 9.06092 5.43419C9.06092 5.602 9.12759 5.76294 9.24625 5.8816C9.36491 6.00026 9.52585 6.067 9.69366 6.067Z"
												fill="black"
											/>
											<path
												d="M3.66494 13.776H1.20577C1.15436 13.776 1.10346 13.7861 1.05597 13.8058C1.00848 13.8255 0.965329 13.8543 0.928989 13.8907C0.892649 13.927 0.863829 13.9702 0.844176 14.0177C0.824524 14.0652 0.814424 14.1161 0.814453 14.1675V22.5604C0.814463 22.6642 0.855695 22.7637 0.929079 22.8371C1.00246 22.9105 1.10199 22.9517 1.20577 22.9517H3.66494C3.89113 22.9516 4.10804 22.8618 4.26796 22.7018C4.42789 22.5419 4.51773 22.3249 4.51773 22.0988V14.6288C4.51768 14.4026 4.42781 14.1857 4.2679 14.0258C4.10798 13.8659 3.8911 13.776 3.66494 13.776Z"
												fill="black"
											/>
											<path
												d="M19.1228 14.7616C18.9928 14.5636 18.8155 14.4012 18.607 14.2888C18.3986 14.1765 18.1654 14.1178 17.9286 14.1181H16.9648C16.5513 14.1173 16.1469 14.2396 15.8032 14.4696C15.4596 14.6995 15.1922 15.0267 15.0352 15.4092C14.9421 15.6316 14.8122 15.8368 14.6512 16.0162C14.3775 16.4365 14.0071 16.7852 13.5711 17.0331C13.135 17.2809 12.646 17.4208 12.1448 17.4409L9.29021 17.4411C9.15594 17.4411 9.02718 17.3878 8.93224 17.2929C8.8373 17.1979 8.78396 17.0691 8.78396 16.9349C8.78396 16.8006 8.8373 16.6719 8.93224 16.5769C9.02718 16.482 9.15594 16.4286 9.29021 16.4286H12.1313C12.4963 16.4193 12.8509 16.3052 13.1529 16.0999V16.0828C13.1539 15.8251 13.1041 15.5699 13.0062 15.3316C12.9083 15.0933 12.7643 14.8766 12.5825 14.6941C12.4007 14.5116 12.1846 14.3667 11.9467 14.2679C11.7088 14.1691 11.4537 14.1182 11.1961 14.1181H9.10132C8.71856 14.117 8.33936 14.1917 7.98557 14.3378C7.63178 14.4839 7.3104 14.6985 7.03995 14.9694L6.98647 15.0227C6.59013 15.4184 6.08119 15.682 5.5293 15.7774V21.3693H13.1686C14.3012 21.37 15.4092 21.0383 16.3551 20.4152C17.301 19.7922 18.0433 18.9052 18.4898 17.8643L19.2424 16.1127C19.3362 15.8953 19.3744 15.6579 19.3535 15.422C19.3327 15.1861 19.2534 14.9591 19.1228 14.7616Z"
												fill="black"
											/>
										</svg>

										{t("Cash")}
									</label>
								</div> */}
							</div>
						</div>
						<div className="checkout-card cont-pay-dts wow fadeInUp">
							<div className="sec_head">
								<h4 className="m-0">{t("Payment Detail")}</h4>
							</div>
							<div className="px-3 mt-3 d-flex justify-content-between">
								<p className="m-0">{t("Sub Total")}</p>
								{isLogin === 0 && (
									<span className="sub_total">
										{totalPrice.toFixed(3)} {t("KWD")}
									</span>
								)}
								{isLogin === 1 && (
									<span className="sub_total">
										{(totalPrice - deliveryChargess - cashInDelivery).toFixed(
											3
										)}{" "}
										{t("KWD")}
									</span>
								)}
							</div>

							<div className="p-3 mb-0">
								{/* Delivery Charges */}
								{!!deliveryChargess && isLogin === 1 && (
									<div className="mb-2">
										<p className="m-0">{t("Delivery Charges")}</p>
										<span className="delivery_charges">
											{deliveryChargess.toFixed(3)} {t("KWD")}
										</span>
									</div>
								)}
								{deliveryPossibility?.delivery_possibility && isLogin === 0 && (
									<div className="mb-2">
										<p className="m-0">{t("Delivery Charges")}</p>
										<span className="delivery_charges">
											{deliveryPossibility?.delivery_all_area
												? deliveryPossibility?.delivery_fee?.toFixed(3)
												: formData?.area_id?.delivery_fee?.toFixed(3)}{" "}
											{t("KWD")}
										</span>
									</div>
								)}
								{/* Cash in Delivery */}
								{paymentMethod === "cash" &&
									!!cashInDelivery &&
									isLogin === 1 && (
										<div className="mb-2">
											<p className="m-0">{t("Cash in Delivery")}</p>
											<span className="delivery_charges">
												{cashInDelivery.toFixed(3)} {t("KWD")}
											</span>
										</div>
									)}
								{paymentMethod === "cash" &&
									deliveryPossibility?.delivery_possibility &&
									isLogin === 0 && (
										<div className="mb-2">
											<p className="m-0">{t("Cash in Delivery")}</p>
											<span className="delivery_charges">
												{deliveryPossibility?.cash_in_delivery?.toFixed(3)}{" "}
												{t("KWD")}
											</span>
										</div>
									)}
								{!!discountAmount && (
									<div className="mb-2">
										<p className="m-0">{t("Discount")}</p>
										<span className="discount_amount">
											- {discountAmount.toFixed(3)} {t("KWD")}
										</span>
									</div>
								)}
								{!discountAmount && !!couponDetails && (
									<div className="mb-2">
										<p className="m-0">{t("Discount")}</p>
										<span className="discount_amount">
											-{" "}
											{couponDetails?.coupon_type === "percentage"
												? couponDetails?.coupon_value
												: couponDetails?.coupon_value.toFixed(3)}{" "}
											{couponDetails?.coupon_type === "percentage"
												? "%"
												: t("KWD")}
										</span>
									</div>
								)}
								{/* Total */}
								{isLogin === 1 && (
									<div className="mb-2">
										<p className="m-0">{t("Total")}</p>
										<span className="total_price">
											{totalPriceAfterDis.toFixed(3)} {t("KWD")}
										</span>
									</div>
								)}
								{isLogin === 0 && (
									<div className="mb-2">
										<p className="m-0 fw-bold">{t("Total")}</p>
										<span className="total_price fw-bold">
											{(
												totalPriceAfterDis +
												(paymentMethod === "cash" &&
												deliveryPossibility?.delivery_possibility
													? deliveryPossibility?.cash_in_delivery
													: 0) +
												(deliveryPossibility?.delivery_all_area
													? deliveryPossibility?.delivery_fee
													: formData?.area_id?.delivery_fee || 0) -
												(formData?.area_id?.delivery_fee || 0)
											).toFixed(3)}{" "}
											{t("KWD")}
										</span>
									</div>
								)}
								<Button
									className="submit-order w-100 fw-bold d-block"
									variant="primary"
									onClick={() => submitOrder()}>
									<span>{t("Submit Order")}</span>
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};
export default Checkout;
